import _ from 'lodash'

export default {
    methods: {
        /**
         * Helper function for deleting an items such as order types and item types
         * @param {string} title The title to be displayed within the confirmation message
         * @param {string} message The message for the confirmation popup
         * @param {number} id The id for the item being deleted
         * @param {function} successCallback The callback function for the toast notification
         * @param {string} path The endpoint for the query being made
         */
        deleteType(title, message, id, successCallback, path, errorMsg) {
            // Generate and display confirmation prompt
            this.confirmMessage(title, message).then(result => {
                console.log('result', result)
                if (result) {
                    this.$store
                        .dispatch(path, id)
                        .then(successCallback())
                        .catch(error => {
                            console.error(error)
                            this.doToast('Error!', errorMsg, 'danger')
                        })
                }
            })
        },

        /**
         * Generalized helper function for deleting an item
         * @param {object} notificationFields
         * @param {string} notificationFields.type The type of item being deleted
         * @param {string} notificationFields.errorMsg
         * @param {object} model
         * @param {object} routes
         * @param {string} routes.baseRoute The route the user will be redirected to after the item is deleted
         * @param {string} routes.deleteRoute
         */
        deleteItem(notificationFields, model, routes) {
            // Destructure necessary objects
            const { type, errorMsg } = notificationFields
            const { baseRoute, deleteRoute } = routes

            // Generate and display confirmation prompt
            const title = `Delete ${type}?`
            const message = `Are you sure you want to delete ${model.name}?`
            this.confirmMessage(title, message).then(result => {
                console.log('result', result)
                if (result) {
                    this.$store
                        .dispatch(deleteRoute, model.id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                `${type} has successfully been deleted.`,
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast('Error!', errorMsg, 'danger')
                        })
                        .finally(
                            _.debounce(() => {
                                this.$router.push({ path: baseRoute })
                            }, 1000)
                        )
                }
            })
        },
    },
}
